"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const react_hooks_1 = require("@apollo/react-hooks");
const apollo_cache_inmemory_1 = require("apollo-cache-inmemory");
const apollo_client_1 = require("apollo-client");
const apollo_link_1 = require("apollo-link");
const apollo_link_batch_http_1 = require("apollo-link-batch-http");
const apollo_link_ws_1 = require("apollo-link-ws");
const apollo_upload_client_1 = require("apollo-upload-client");
const apollo_utilities_1 = require("apollo-utilities");
const react_1 = tslib_1.__importStar(require("react"));
const react_apollo_network_status_1 = require("react-apollo-network-status");
const react_router_dom_1 = require("react-router-dom");
const react_stripe_elements_1 = require("react-stripe-elements");
const fetchWithProgress_1 = require("./fetchWithProgress");
const react_hanger_1 = require("react-hanger");
const utils_1 = require("@osmosys/utils");
let tz = 'Unknown TZ';
try {
    tz = Intl.DateTimeFormat().resolvedOptions().timeZone;
}
catch (e) {
    tz = `Offset ${new Date().getTimezoneOffset()}`;
}
const wsLink = new apollo_link_ws_1.WebSocketLink({
    options: {
        connectionParams: () => {
            return {
                'osmosys-timezone': tz,
            };
        },
        inactivityTimeout: 5 * 1000,
        lazy: true,
        reconnect: true,
    },
    uri: `${window.location.protocol === 'http:' ? 'ws:' : 'wss:'}//${window.location.host}/api/v1/subscriptions`,
});
const fragmentMatcher = new apollo_cache_inmemory_1.IntrospectionFragmentMatcher({
    introspectionQueryResultData: {
        __schema: {
            types: [
                {
                    kind: 'UNION',
                    name: 'IntegrationItem',
                    possibleTypes: [
                        {
                            name: 'Mailjet',
                        },
                        {
                            name: 'ContentSystem',
                        },
                        {
                            name: 'Sailthru',
                        },
                        {
                            name: 'Salesforce',
                        },
                        {
                            name: 'ActiveCampaign',
                        },
                        {
                            name: 'Mailchimp',
                        },
                        {
                            name: 'CampaignMonitor',
                        },
                        {
                            name: 'ContentSystem',
                        },
                    ],
                },
            ],
        },
    },
});
const opts = {
    credentials: 'include',
    fetch: fetchWithProgress_1.fetchWithProgress,
    headers: {
        'osmosys-timezone': tz,
    },
    uri: '/api/v1/graphql',
};
const httpLink = apollo_link_1.ApolloLink.split(operation => operation.getContext().version === 1, new apollo_link_batch_http_1.BatchHttpLink(Object.assign({ batchMax: 5 }, opts)), apollo_upload_client_1.createUploadLink(opts));
const link = apollo_link_1.ApolloLink.split(({ query }) => {
    const { kind, operation } = apollo_utilities_1.getMainDefinition(query);
    return kind === 'OperationDefinition' && operation === 'subscription';
}, wsLink, httpLink);
const cache = new apollo_cache_inmemory_1.InMemoryCache({
    dataIdFromObject: (obj) => {
        var _a, _b, _c, _d, _e, _f, _g, _h;
        if (['SalesforceCategory'].includes((_a = obj) === null || _a === void 0 ? void 0 : _a.__typename) &&
            !utils_1.isDefined((_b = obj) === null || _b === void 0 ? void 0 : _b.id) &&
            utils_1.isDefined((_c = obj) === null || _c === void 0 ? void 0 : _c.salesforceId)) {
            return `${obj.__typename}:salesforceId:${(_d = obj) === null || _d === void 0 ? void 0 : _d.salesforceId}`;
        }
        if (['EmailList', 'EmailSegment'].includes((_e = obj) === null || _e === void 0 ? void 0 : _e.__typename) &&
            !utils_1.isDefined((_f = obj) === null || _f === void 0 ? void 0 : _f.id) &&
            utils_1.isDefined((_g = obj) === null || _g === void 0 ? void 0 : _g.espId)) {
            return `${obj.__typename}:espId:${(_h = obj) === null || _h === void 0 ? void 0 : _h.espId}`; // Produces: e.g. EmailList:l32kg74 or EmailSegment:fdg934 or EmailSegment:123 or EmailList:xyz123
        }
        return apollo_cache_inmemory_1.defaultDataIdFromObject(obj);
    },
    fragmentMatcher,
    freezeResults: true,
});
const defaultOptions = {
    query: {
        errorPolicy: 'all',
    },
    watchQuery: {
    // fetchPolicy: 'network-only',
    },
};
exports.client = new apollo_client_1.ApolloClient({
    cache,
    defaultOptions,
    link,
    name: `${window.location.hostname || 'osmosys'}`,
    version: `${process.env.GIT_SHA || '0.0.0-dev'}`,
});
exports.OsmosysProvider = ({ children }) => {
    const { state, setState } = react_hanger_1.useSetState({
        stripe: null,
        stripeIsEnabled: false,
    });
    react_1.useEffect(() => {
        if (state.stripe) {
            const Stripe = window.Stripe || null;
            if (Stripe) {
                try {
                    setState({
                        stripe: Stripe('pk_test_hivw0okSTuy3z3uyMJKLNL37'),
                    });
                }
                catch (e) {
                    console.warn('Failed to load Stripe', e);
                }
            }
            else {
                const sJS = document.querySelector('#stripe-js');
                if (sJS) {
                    sJS.addEventListener('load', () => {
                        try {
                            setState({
                                stripe: Stripe('pk_test_hivw0okSTuy3z3uyMJKLNL37'),
                            });
                        }
                        catch (e) {
                            console.warn('Failed to load Stripe', e);
                        }
                    });
                }
            }
        }
    }, [state.stripeIsEnabled]);
    const isTest = process.env.NODE_ENV === 'test';
    if (state.stripeIsEnabled && state.stripe && !isTest) {
        children = (react_1.default.createElement(react_stripe_elements_1.StripeProvider, { stripe: state.stripe },
            react_1.default.createElement(react_stripe_elements_1.Elements, null,
                react_1.default.createElement(react_1.default.Fragment, null, children))));
    }
    return (react_1.default.createElement(react_hooks_1.ApolloProvider, { client: exports.client },
        react_1.default.createElement(react_apollo_network_status_1.ApolloNetworkStatusProvider, null,
            react_1.default.createElement(react_router_dom_1.BrowserRouter, null, children))));
};
//# sourceMappingURL=OsmosysProvider.js.map